/**
 * Health API
 */

import { resolveApiBaseUrl } from './fetch';

function shouldUseProxy(): boolean {
  if (!import.meta.env.DEV) return false;
  const base = resolveApiBaseUrl();
  if (!base) return false;
  try {
    const baseHost = new URL(base).hostname;
    const currentHost = window.location.hostname;
    return currentHost !== baseHost &&
      currentHost !== 'localhost' &&
      currentHost !== '127.0.0.1';
  } catch {
    return false;
  }
}

export async function checkBackendHealth(): Promise<boolean> {
  try {
    const healthUrl = shouldUseProxy()
      ? '/health/ready'
      : (() => { const b = resolveApiBaseUrl(); return b ? `${b}/health/ready` : '/health/ready'; })();
    const response = await fetch(healthUrl, {
      method: 'GET',
      signal: AbortSignal.timeout(5000),
    });
    return response.ok;
  } catch {
    return false;
  }
}
